import ImageUpload from "components/ImageUpload";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import React from "react";
import "../style.scss";
import TextField from "@mui/material/TextField";
import { Business } from "types/Dashboard";

type Props = {
  values: Business;
  setFieldValue: (field: string, value: any) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any, Element>) => void;
};
const DesignForm: React.FC<Props> = (props) => {
  const { values, handleChange, handleBlur, setFieldValue } = props;

  const renderColorCode = (colorCode: string, field: string) => {
    if (!colorCode) {
      return field === "background_color" ? "#ffffff" : "#000000";
    }
    return colorCode.includes("#") ? colorCode : `#${colorCode}`;
  };
  return (
    <MDBox>
      <MDBox mt={2} ml={1} width={"75%"}>
        <MDInput
          type="text"
          label="Title"
          name="name"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.name}
          fullWidth
        />
      </MDBox>
      <MDBox mt={3} ml={1} width={"75%"}>
        <MDInput
          type="text"
          label="Description"
          name="description"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.description}
          fullWidth
        />
      </MDBox>
      <MDBox mt={3} ml={1} width={"75%"}>
        <MDInput
          type="text"
          label="Address"
          name="address"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.address}
          fullWidth
        />
      </MDBox>
      <MDBox mt={3} ml={1} width={"75%"}>
        <MDInput
          type="text"
          label="Opening Hours"
          name="opening_hours"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.opening_hours}
          fullWidth
        />
      </MDBox>
      <MDBox mt={3} ml={1} width={"75%"}>
        <TextField
          id="outlined-multiline-static"
          label="Reward Condition"
          helperText="Please put * on each of your t&c. (Max of 4 agreements. 200 words per agreement)"
          fullWidth
          multiline
          name={"reward_condition"}
          rows={6}
          value={values.reward_condition}
          inputProps={{ maxLength: 1206 }}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </MDBox>
      <MDBox display="flex" mt={3} ml={1}>
        <MDBox mr={5}>
          <ImageUpload
            title="Logo"
            selectedImage={values.cafe_logo}
            handleImageUpload={(image) => setFieldValue("logo_url", image)}
            disabled
          />
        </MDBox>
      </MDBox>

      <MDBox mt={3} ml={1}>
        <MDInput
          type="color"
          label="Background Color"
          name="background_color"
          onChange={(e) => {
            const color = e.target.value.substring(1).toUpperCase();
            setFieldValue("background_color", `#${color}`);
          }}
          value={renderColorCode(values.background_color, "background_color")}
          sx={{ width: "15ch" }}
        />
      </MDBox>
      <MDBox mt={3} ml={1}>
        <MDInput
          type="color"
          label="Stamp Color"
          name="stamp_color"
          onChange={(e) => {
            const color = e.target.value.substring(1).toUpperCase();
            setFieldValue("stamp_color", `#${color}`);
          }}
          value={renderColorCode(values.stamp_color, "stamp_color")}
          sx={{ width: "15ch" }}
        />
      </MDBox>
    </MDBox>
  );
};
export default DesignForm;
